import * as t from "io-ts";
import { PlainBrand } from "../brands/PlainBrand";

export const PlainPassword = t.brand(
  t.string,
  (n): n is t.Branded<string, PlainBrand> => true,
  "Plain"
);
export type PlainPassword = t.TypeOf<typeof PlainPassword>;
export type PlainPasswordOutput = typeof PlainPassword._O;

interface HashedBrand {
  readonly Hashed: unique symbol;
}

export const HashedPassword = t.brand(
  t.string,
  (n): n is t.Branded<string, HashedBrand> => true,
  "Hashed"
);
export type HashedPassword = t.TypeOf<typeof HashedPassword>;
export type HashedPasswordOutput = typeof HashedPassword._O;

